import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import moment from "moment";
import { updateField } from "@joandvgv/vuex-map-fields";
import Vue from "vue";
export const SET_SESSION_DETAILS = "SET_SESSION_DETAILS";
export const SET_NOTIFICATION_PREFERENCES = "SET_NOTIFICATION_PREFERENCES";
export const SET_PERSONAL_DETAILS = "SET_PERSONAL_DETAILS";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_EMAIL_VERIFICATION = "SET_EMAIL_VERIFICATION";
export const SET_SELECTED_APPLICATION_ID = "SET_SELECTED_APPLICATION_ID";
export const SET_BROKERAGE_SUBDOMAIN = "SET_BROKERAGE_SUBDOMAIN";
export const SET_BROKERAGE_ID = "SET_BROKERAGE_ID";
export const SET_ACCOUNT_SUBDOMAIN = "SET_ACCOUNT_SUBDOMAIN";
export const SET_LAST_CACHE_CHECK = "SET_LAST_CACHE_CHECK";
export const SET_AGENT_ACCOUNT_DETAILS = "SET_AGENT_ACCOUNT_DETAILS";
export const SET_EMAIL_VERIFIED = "SET_EMAIL_VERIFIED";
export const SET_EMAIL_SENT = "SET_EMAIL_SENT";
export const SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK = "SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK";
export const SET_TOKEN = "SET_TOKEN";
export const SET_ACCOUNT_AGENTS = "SET_ACCOUNT_AGENTS";
export const SET_LENDER_DATA = "SET_LENDER_DATA";
export const SET_DOCUMENTS_COUNT = "SET_DOCUMENTS_COUNT";
export const SET_TIED_BROKERAGES = "SET_TIED_BROKERAGES";
const mutations = {
  [SET_SESSION_DETAILS]: (state, session) => {
    for (const key in session) {
      state[key] = session[key];
    }
    const expirationTime = state["expires_in"];
    const now = moment();
    now.add(expirationTime, "second");
    state.expiration = now.toString();
  },
  [SET_NOTIFICATION_PREFERENCES]: (state, {
    preferences
  }) => {
    state.notificationPreferences = preferences;
  },
  [SET_PERSONAL_DETAILS]: (state, personalDetails) => {
    state.userDetails = _objectSpread(_objectSpread({}, state.userDetails), personalDetails);
  },
  [SET_ACCOUNT_DETAILS]: (state, {
    accountDetails
  }) => {
    state.accountDetails = _objectSpread(_objectSpread({}, state.accountDetails), accountDetails);
  },
  [SET_BROKERAGE_SUBDOMAIN]: (state, {
    brokerageId
  }) => {
    var _brokerageDetails$tie;
    const {
      brokerageDetails
    } = state;
    const tiedBrokerages = (_brokerageDetails$tie = brokerageDetails.tiedBrokerages) == null ? void 0 : _reduceInstanceProperty(_brokerageDetails$tie).call(_brokerageDetails$tie, (acc, element) => {
      if (element.brokerageId == brokerageId) {
        return [element, ...acc];
      }
      return [...acc, element];
    }, []);
    brokerageDetails.tiedBrokerages = tiedBrokerages;
    state.brokerageDetails = _objectSpread({}, brokerageDetails);
  },
  [SET_BROKERAGE_ID]: (state, {
    brokerageId
  }) => {
    state.brokerageId = brokerageId;
  },
  [SET_EMAIL_VERIFICATION]: (state, {
    pendingEmailVerification,
    email
  }) => {
    state.verification.pendingEmailVerification = pendingEmailVerification;
    state.userDetails.email = email;
  },
  [SET_EMAIL_VERIFIED]: (state, {
    verified
  }) => {
    Vue.set(state.accountDetails, "emailVerified", verified);
  },
  [SET_SELECTED_APPLICATION_ID]: (state, {
    applicationId
  }) => {
    state.selectedApplicationId = applicationId.toString();
  },
  [SET_ACCOUNT_SUBDOMAIN]: (state, {
    subdomain
  }) => {
    state.accountDetails.accountSubdomain = subdomain;
  },
  [SET_LAST_CACHE_CHECK]: (state, lastCacheCheck) => {
    state.lastCacheCheck = lastCacheCheck;
  },
  [SET_AGENT_ACCOUNT_DETAILS]: (state, agentAccountDetails) => {
    Vue.set(state.public, "agentAccountDetails", agentAccountDetails);
  },
  [SET_EMAIL_SENT]: (state, status) => {
    Vue.set(state, "verificationEmailSent", status);
  },
  [SET_IS_NEW_ACCOUNT_CREATED_EMBEDDED_LINK]: (state, isEmbeddedLink) => {
    state.newAccountCreatedEmbeddedLink = isEmbeddedLink;
  },
  [SET_TOKEN]: (state, {
    token
  }) => {
    state.token = token;
  },
  [SET_ACCOUNT_AGENTS]: (state, agents) => {
    Vue.set(state, "agents", agents);
  },
  [SET_LENDER_DATA]: (state, {
    lenderData
  }) => {
    state.lenderData = lenderData;
  },
  [SET_DOCUMENTS_COUNT]: (state, {
    totalDocuments
  }) => {
    state.lenderData.documentsCount = totalDocuments;
  },
  [SET_TIED_BROKERAGES]: (state, {
    tiedBrokerages
  }) => {
    state.brokerageDetails.tiedBrokerages = tiedBrokerages;
  },
  updateField
};
export default mutations;